/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 25.05.2016
 *
 */

import { RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import LogicalLayerWebApi from '../webapi/LogicalLayerWebApi';
import ClassNames from '../constants/ClassNames';

const className = ClassNames.LogicalLayer;

export default {

    list: (name, query) => RemoteDataActions.list(name, className, query),
    item: (name, query) => RemoteDataActions.item(name, className, query),
    moreItems: (name, query) => RemoteDataActions.moreItems(name, className, query),

    allViewableGroupedList: (name) => RemoteDataActions.list(name, className, {}, LogicalLayerWebApi.listViewableLogicalLayersByGroupScope),

    /*unsetSelectedLogicalLayer( name ) {
        AppContext.getDispatcher().dispatch({
                type: ActionTypesBase.RESET_DATA,
                item: null,
                meta: {
                    name,
                    storeKey: StoreKeys.LOGIC_LAYERS
                }
            }
        );
    }*/
};


// WEBPACK FOOTER //
// ./js/actions/LogicalLayerActions.js